import { mockIndex } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">漫画分类索引</h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            全站漫画分类一目了然，按类型快速找到你喜欢的漫画世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {mockIndex.slice(0, 7).map((item, i) => (
            <div
              key={i}
              className={`group flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-lg cursor-pointer hover:border-primary-200 transition-all duration-300 ${
                i === 6 ? 'sm:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-heading text-foreground-900">{item.title}</h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count.toLocaleString()}部</span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}